import { toast } from 'react-toastify'
import { getTeamMemberList, JobList, UpdateJobDetails, CreateJobDetails } from '../../../repository/teamManagementRepo'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { requiredMessage, requiredSelect } from '../../../utils'
import { getAllShiftList } from '../../../repository/shiftRepo'
import { getAllRoleList } from '../../../repository/auth'
import moment from 'moment'
import useReduxStore from '../../../hooks/useReduxStore'

const UseJobDetails = () => {
  const [jobDetailsModal, setJobDetailsModal] = useState({
    open: false,
    data: {},
    type: '',
  })
  const [jobDetailsInputs, setJobDetailsInputs] = useState({
    designation: '',
    dateOfJoining: '',
    elCalculate: false,
    shift: '',
    empType: '',
    role_id: '',
    reportingManager: null,
    action: '',
    probationDays: '',
    empStatus: 'ACTIVE',
    remark: '',
    actionDate: null,
  })
  const [error, setError] = useState({})
  const [spinner, setSpinner] = useState(false)
  const [allShiftList, setAllShiftList] = useState([])
  const [allRolesList, setAllRoleList] = useState([])
  const [reportManagerData, setReportManagerData] = useState([])

  const [jobDetailsList, setJobDetailsList] = useState([])
  const { agentId } = useParams()
  const { pathname } = useLocation()
  const splitLocation = pathname.split('/')
  const { selector: user } = useReduxStore('auth')
  // console.log(user?.userInfo?._id,'user')

  // console.log(error, 'error')
  // console.log(jobDetailsInputs, 'jobDetailsInputs')

  useEffect(() => {
    if (splitLocation?.[3] === 'job-details') {
      getDetails(agentId)
    } else {
      getDetails(user?.userInfo?._id)
    }
    AllShiftList()
    getAllRolesList()
    getReportManagers()
  }, [])
  // console.log(jobDetailsList?.[0], 'jobDetailsList')
  // console.log(jobDetailsModal, 'jobDetailsModal')
  const AllShiftList = async () => {
    try {
      setSpinner(true)
      let response = await getAllShiftList()
      setAllShiftList(response.data)
    } catch (error) {
      // toast.error(error.message)
    }
    setSpinner(false)
  }
  const getAllRolesList = async () => {
    try {
      setSpinner(true)
      let response = await getAllRoleList()
      setAllRoleList(response.data)
    } catch (error) {
      // toast.error(error.message)
    }
    setSpinner(false)
  }
  const getReportManagers = async () => {
    try {
      setSpinner(true)
      let response = await getTeamMemberList({ count: 1000 })

      for (let element of response?.data) {
        element.fullNameAndEmail = `${element.firstName} ${element.lastName} (${element.email})`
      }

      setReportManagerData(response?.data)
    } catch (error) {
      //  toast.error(error.message)
    }
    setSpinner(false)
  }
  const getDetails = async (agentId) => {
    const payload = {
      userId: agentId,
    }
    try {
      setSpinner(true)
      let response = await JobList(payload)
      setJobDetailsList(response)
    } catch (error) {
      // toast.error(error.message)
    }
    setSpinner(false)
  }
  const clear = () => {
    setJobDetailsInputs({
      designation: '',
      dateOfJoining: '',
      elCalculate: false,
      shift: '',
      empType: '',
      role_id: '',
      reportingManager: null,
      action: '',
      probationDays: '',
      empStatus: 'ACTIVE',
      remark: '',
      actionDate: null,
    })
    setJobDetailsModal({ open: false, data: {}, type: '' })
    setError({})
  }
  const clearOnStatus = () => {
    setError({})
    setJobDetailsInputs((pre) => ({
      ...pre,
      designation: '',
      dateOfJoining: '',
      elCalculate: false,
      shift: '',
      empType: '',
      role_id: '',
      reportingManager: null,
      action: '',
      probationDays: '',
      remark: '',
      actionDate: null,
    }))
  }
  const getJobDetails = (id, data = {}) => {
    if (splitLocation?.[3] === 'job-details') {
      // const { designation, dateOfJoining, isStartElCalculate, shift_id, employeeType, role_id, reportingManager_id, probationDays } = jobDetailsList?.[0]
      const { designation, dateOfJoining, isStartElCalculate, shift_id, employeeType, role_id, reportingManager_id, probationDays, employmentStatus, employmentStatusRemarks, employmentStatusDate } =
        data
      setJobDetailsInputs({
        designation: designation,
        dateOfJoining: dateOfJoining ? new Date(dateOfJoining) : null,
        elCalculate: isStartElCalculate,
        shift: shift_id,
        empType: employeeType,
        role_id: role_id,
        reportingManager: reportingManager_id,
        probationDays: probationDays,
        empStatus: employmentStatus || 'ACTIVE',
        remark: employmentStatusRemarks,
        actionDate: new Date(employmentStatusDate),
      })
      setJobDetailsModal((prev) => ({ ...prev, open: true, data: data }))
    } else {
      getDetails(id)
      setJobDetailsModal((prev) => ({ ...prev, open: true }))
    }
  }
  const handleBlur = (event) => {
    const { name, value } = event.target
    // Check if value is a string before calling .trim()
    if (typeof value === 'string' && !value.trim()?.length) {
      setError((pre) => ({ ...pre, [name]: errorMessage[name] }))
    }
    // !value?.trim()?.length && setError(pre => ({ ...pre, [name]: errorMessage[name] }))
  }
  const errorMessage = {
    role_id: requiredSelect('role'),
    dateOfJoining: requiredSelect('date of joining'),
    probationDays: requiredMessage('probation days'),
    // status: requiredMessage('status'),
    empType: requiredMessage('employee type'),
    shift: requiredSelect('shift'),
    empStatus: requiredSelect('employment status'),
    actionDate: requiredSelect('action date'),
    remark: requiredMessage('remark'),
  }
  const jobDetailisValid = () => {
    const errorObj = {}
    if (!jobDetailsInputs.empStatus) {
      errorObj['empStatus'] = errorMessage['empStatus']
    }
    if (jobDetailsInputs?.empStatus === 'ACTIVE') {
      if (!jobDetailsInputs.dateOfJoining) {
        errorObj['dateOfJoining'] = errorMessage['dateOfJoining']
      }
      if (!jobDetailsInputs.empType) {
        errorObj['empType'] = errorMessage['empType']
      }
      if (!jobDetailsInputs.role_id) {
        errorObj['role_id'] = errorMessage['role_id']
      }
      if (!jobDetailsInputs.probationDays && jobDetailsInputs.probationDays !== 0) {
        errorObj['probationDays'] = errorMessage['probationDays']
      }
      if (!jobDetailsInputs.shift) {
        errorObj['shift'] = errorMessage['shift']
      }
    } else {
      if (!jobDetailsInputs.actionDate) {
        errorObj['actionDate'] = errorMessage['actionDate']
      }
      if (!jobDetailsInputs.remark) {
        errorObj['remark'] = errorMessage['remark']
      }
    }
    setError(errorObj)
    return !Object.keys(errorObj)?.length
  }
  const handleInputChange = (event, index = null, arrayName = null) => {
    const { name, value } = event.target

    setJobDetailsInputs((prevProps) => {
      if (arrayName !== null && index !== null) {
        // Handle array of objects
        const newArray = [...prevProps[arrayName]]
        newArray[index] = {
          ...newArray[index],
          [name]: value,
        }
        return {
          ...prevProps,
          [arrayName]: newArray,
        }
      } else {
        // Handle simple fields
        return {
          ...prevProps,
          [name]: value,
        }
      }
    })

    if (typeof value === 'string' && value.trim()?.length > 0) {
      setError((prevErrors) => {
        if (arrayName !== null && index !== null) {
          if (prevErrors[arrayName] && prevErrors[arrayName][index]) {
            delete prevErrors[arrayName][index][name]
            if (Object.keys(prevErrors[arrayName][index])?.length === 0) {
              delete prevErrors[arrayName][index]
            }
          }
        } else {
          delete prevErrors[name]
        }
        return { ...prevErrors }
      })
    }
  }
  const handleJobDetailupdate = async (id) => {
    if (!jobDetailisValid()) return
    const { designation, dateOfJoining, shift, role_id, reportingManager, probationDays, empType, elCalculate, remark, empStatus, actionDate } = jobDetailsInputs

    const LatestJobDetail = jobDetailsList?.data?.[0]?._id === jobDetailsModal?.data?._id
    const payload = {
      _id: jobDetailsModal?.data?._id,
      designation: designation,
      dateOfJoining: moment(dateOfJoining).format('MM-DD-YYYY'),
      shift_id: shift,
      role_id: role_id,
      reportingManager_id: reportingManager,
      probationDays: probationDays,
      employeeType: empType,
      isStartElCalculate: elCalculate,
      isLatestJobDetail: LatestJobDetail,
      userId: id,
      employmentStatusRemarks: remark,
      employmentStatus: empStatus,
    }
    const payloadOther = {
      _id: jobDetailsModal?.data?._id,
      userId: id,
      employmentStatusDate: moment(actionDate).format('MM-DD-YYYY'),
      employmentStatusRemarks: remark,
      employmentStatus: empStatus,
      isLatestJobDetail: LatestJobDetail,
    }
    const finalPayload = jobDetailsInputs?.empStatus === 'ACTIVE' ? payload : payloadOther
    setSpinner(true)
    try {
      let response = await UpdateJobDetails(finalPayload)
      toast.success(response.message)
      getDetails(id)
      clear()
    } catch (err) {
      toast.error(err.message)
    }
    setSpinner(false)
  }
  const handleJobDetailAdd = async (id) => {
    if (!jobDetailisValid()) return
    const { designation, dateOfJoining, shift, role_id, reportingManager, probationDays, empType, elCalculate, remark, empStatus, actionDate } = jobDetailsInputs
    const payload = {
      _id: id,
      designation: designation,
      dateOfJoining: moment(dateOfJoining).format('MM-DD-YYYY'),
      shift_id: shift,
      role_id: role_id,
      reportingManager_id: reportingManager,
      probationDays: probationDays,
      employeeType: empType,
      isStartElCalculate: elCalculate,
      employmentStatusRemarks: remark,
      employmentStatus: empStatus,
    }
    const payloadOther = {
      _id: id,
      employmentStatusDate: moment(actionDate).format('MM-DD-YYYY'),
      employmentStatusRemarks: remark,
      employmentStatus: empStatus,
    }
    const finalPayload = jobDetailsInputs?.empStatus === 'ACTIVE' ? payload : payloadOther
    // console.log(finalPayload, 'payload')
    // return
    setSpinner(true)
    try {
      let response = await CreateJobDetails(finalPayload)
      toast.success(response.message)
      getDetails(id)
      clear()
      setJobDetailsModal((prev) => ({ ...prev, open: false }))
    } catch (err) {
      toast.error(err.message)
    }
    setSpinner(false)
  }
  const handleDateChange = (date, field, index = null, arrayName = null) => {
    setJobDetailsInputs((prev) => {
      if (arrayName && index !== null) {
        // Handle date change for array of objects
        const updatedArray = [...prev[arrayName]]
        updatedArray[index] = {
          ...updatedArray[index],
          [field]: date,
        }
        return {
          ...prev,
          [arrayName]: updatedArray,
        }
      } else {
        // Handle date change for simple fields
        return {
          ...prev,
          [field]: date,
        }
      }
    })
  }
  return {
    data: {
      jobDetailsModal,
      spinner,
      jobDetailsList,
      jobDetailsInputs,
      error,
      allShiftList,
      allRolesList,
      reportManagerData,
      user,
      splitLocation,
    },
    methods: {
      handleBlur,
      setJobDetailsInputs,
      setError,
      setJobDetailsModal,
      handleInputChange,
      handleDateChange,
      handleJobDetailupdate,
      clear,
      getJobDetails,
      handleJobDetailAdd,
      clearOnStatus,
    },
  }
}

export default UseJobDetails
